import React, { Component } from "react";
import { Link } from "react-router-dom";
import EditConfirm from "../components/alert/EditAlert";
import {
  Button as Btn,
  Card as Cd,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import withStyles from "@material-ui/core/styles/withStyles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import Switch from "@material-ui/core/Switch";
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "../components/Grid/GridItem.jsx";
import CardAvatar from "../components/Card/CardAvatar.jsx";
import imgPlaceholder from "../assets/img/person-placeholder.jpg";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import Icon from "@material-ui/core/Icon";
//redux
import { spinnerService } from "@chevtek/react-spinners";
import * as actionTypes from "../redux/actions";

import gql from "graphql-tag";
import { getInspector } from "../graphql/queries";
import { updateInspector } from "../graphql/mutations";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
let qualificationsArray = [];
var _ = require("lodash");
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
var self = null;
//calculating current date for file upload
let today = new Date();
let month =
  today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
let date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();

let currentDate = `${today.getFullYear()}-${month}-${date}`;
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
function Qualifications(prop) {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [file, setFile] = React.useState(null);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose(id) {
    setOpen(false);
    if (id === 1) {
      prop.addQualification(title, file);
      setTitle("");
      setFile(null);
    }
  }
  return (
    <div>
      <Button
        style={{ float: "right" }}
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
      >
        +
      </Button>
      <Dialog
        open={open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ padding: 20 }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Add Qualification Details"}
        </DialogTitle>
        <div className="row" style={{ margin: 0 }}>
          <div className="col">
            <Input
              id="skill"
              value={title}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <input type="file" onChange={e => setFile(e.target.files[0])} />
          </div>
        </div>
        <DialogActions>
          <Button onClick={() => handleClose(0)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleClose(1)} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
function Experiences(prop) {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [city, setCity] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [currentlyWorking, setCurrentlyWorking] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose(id) {
    setOpen(false);
    if (id === 1) {
      title,
        company,
        city,
        country,
        description,
        endDate,
        startDate,
        currentlyWorking;
      prop.addExperience(
        title,
        company,
        city,
        country,
        description,
        endDate,
        startDate,
        currentlyWorking
      );
      setTitle("");
      setCompany("");
      setCity("");
      setDescription("");
      setEndDate("");
      setStartDate("");
      setCurrentlyWorking("");
      setCountry("");
    }
  }
  return (
    <div>
      <Button
        style={{ float: "right" }}
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
      >
        +
      </Button>
      <Dialog
        open={open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Add Employment Details"}
        </DialogTitle>
        <div className="row" style={{ margin: 0 }}>
          <div className="col">
            <Input
              placeholder="Company"
              value={company}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCompany(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="Title"
              value={title}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="City"
              value={city}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCity(e.target.value)}
            />
          </div>
          <div className="col">
            <Input
              placeholder="Country"
              value={country}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCountry(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="Start Date"
              type="date"
              value={startDate}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setStartDate(e.target.value)}
            />
          </div>
          <div className="col">
            <Input
              placeholder="End Date"
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <input
              type="checkbox"
              checked={currentlyWorking}
              onChange={e => setCurrentlyWorking(e.target.checked)}
            />
            <span> I currently work here</span>
          </div>
        </div>
        <br />
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="Description"
              value={description}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setDescription(e.target.value)}
            />
          </div>
        </div>
        <DialogActions>
          <Button onClick={() => handleClose(0)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleClose(1)} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
class UpdateInspector extends Component {
  constructor(props) {
    super(props);
    self = this;
    this.state = {
      fName: "",
      lName: "",
      email: "",
      password: "",
      cPassword: "",
      address: "",
      city: "",
      st: "",
      phoneNum: "",
      date: "",
      skills: [],
      qualifications: [],
      experiences: [],
      inspectorType: [],
      deletedInspectorTypes: [],
      iamMechanic: false,
      iamInspector: false,
      picture: imgPlaceholder,
      isPicChanged: false,
      rawPicture: {},
      uploadedPicKey: "",
      picS3Obj: {}
    };
  }
  addQualification(title, file) {
    "qualifications", self.state;
    let qualifications = [];
    if (self.state.qualifications !== null) {
      qualifications = [...self.state.qualifications];
    }
    qualifications;
    qualifications.push({ title, file });
    self.setState({ qualifications });
  }
  addExperience(
    title,
    company,
    city,
    country,
    description,
    endDate,
    startDate,
    currentlyWorking
  ) {
    "experiences", self.state;

    let experiences = [];
    if (self.state.experiences !== null) {
      experiences = [...self.state.experiences];
    }
    experiences;
    experiences.push({
      jobTitle: title,
      company,
      location: {
        city,
        country
      },
      description,
      endDate,
      startDate,
      currentlyWorking
    });
    self.setState({ experiences });
  }

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  addSkill = data => {
    var skills = [];
    if (self.state.skills !== null) {
      skills = [...self.state.skills];
    }
    skills;
    skills.push(data);
    self.setState({ skills, skill: "" });
  };
  deleteSkill = data => {
    data;
    var skills = [...this.state.skills];
    skills = skills.filter(obj => obj !== data);
    this.setState({ skills });
  };
  deleteInspectorType = data => {
    data;
    var inspectorType = [...this.state.inspectorType];
    inspectorType = inspectorType.filter(obj => obj !== data);
    //for deleting user from cognito we need to track del insp types
    let deletedInspectorTypes = [...this.state.deletedInspectorTypes];
    deletedInspectorTypes = deletedInspectorTypes.push(data);
    this.setState({ inspectorType, deletedInspectorTypes });
  };
  deleteQualification = title => {
    title;
    var qualifications = [...this.state.qualifications];
    qualifications = qualifications.filter(obj => obj.title !== title);
    this.setState({ qualifications });
  };
  deleteExperience = title => {
    title;
    var experiences = [...this.state.experiences];
    experiences = experiences.filter(obj => obj.jobTitle !== title);
    this.setState({ experiences });
  };
  async componentDidMount() {
    const { client, user, profile } = this.props;
    let obj = {};
    if (profile === undefined || profile === "" || profile === null) {
      const inspector = await client.query({
        query: gql(getInspector),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      });
      "[inspector.data.getInspector]: ", inspector.data.getInspector;
      obj = inspector.data.getInspector;
    } else obj = profile;

    let iamInspector = obj.inspectorType.includes("INSPECTOR");
    let iamMechanic = obj.inspectorType.includes("MECHANIC");
    this.setState({
      fName: obj.name,
      email: obj.email,
      password: "",
      cPassword: "",
      address: obj.homeAddress,
      city: obj.city,
      st: obj.state,
      phoneNum: obj.phoneNo,
      date: obj.inspectingSince,
      skills: obj.skills,
      qualifications: obj.qualifications,
      experiences: obj.employmentHistory,
      inspectorType: obj.inspectorType,
      iamInspector,
      iamMechanic,
      picS3Obj: obj.picture
    });
    qualificationsArray = obj.qualifications;
    if (
      obj.pictureObj !== undefined ||
      obj.pictureObj !== null ||
      obj.pictureObj !== ""
    ) {
      let pic = obj.picture;
      pic !== null &&
        pic !== "" &&
        Storage.get(pic.key)
          .then(picture => {
            this.setState({ picture });
          })
          .catch(err => {});
    } else this.setState({ picture: obj.pictureObj });
  }
  onInspMechStats = e => {
    this.setState({ [e.target.value]: e.target.checked });
  };
  handleSubmit = async () => {
    // event.preventDefault();
    spinnerService.show("mySpinner");
    ("[Inspector submitted]");
    "[this.state]: ", this.state;

    const { email, password, isPicChanged } = this.state;

    ("[update submitted in]: ");
    const qualif = await this.uploadImages();
    "qualif after await", qualif;

    let experiences = this.state.experiences;
    "[exp]: ", experiences;
    if (experiences !== null && experiences.length !== 0) {
      experiences.map(async (item, index) => {
        delete experiences[index].__typename;
        delete experiences[index].location.__typename;
      });
    }
    "[exp]: modified ", experiences;

    let inspectorType = [];
    if (this.state.iamInspector) inspectorType.push("INSPECTOR");
    if (this.state.iamMechanic) inspectorType.push("MECHANIC");
    try {
      var input = {
        id: this.props.user.username,
        name: this.state.fName,
        homeAddress: this.state.address,
        city: this.state.city,
        state: this.state.st,
        phoneNo: this.state.phoneNum,
        email: this.state.email,
        inspectingSince: this.state.date,
        skills: this.state.skills,
        employmentHistory: experiences,
        qualifications: qualificationsArray,
        inspectorType
      };
      if (isPicChanged) {
        await this.uploadInspectorPic();
      }
      let picObj = {};
      let data = { ...input };
      if (this.state.uploadedPicKey !== "") {
        picObj.key = this.state.uploadedPicKey;
        picObj.bucket = "calbitwebappuploadbucket1254-dev";
        picObj.region = "us-east-2";
        input.picture = picObj;
        data.picture = picObj;
      } else {
        if (this.state.picS3Obj !== "" || this.state.picS3Obj !== null)
          data.picture = this.state.picS3Obj;
      }
      var result = await API.graphql(
        graphqlOperation(updateInspector, { input })
      );
      //update redux store with updated
      data.pictureObj = this.state.picture;
      this.props.updateProfile(data);

      //clear all state
      this.setState({ open: false, uploadedPicKey: "", isPicChanged: false });
      //adjust cognito groups
      this.deleteUserFromCognitoGrp();

      spinnerService.hide("mySpinner");
      toast.success("Profile Updated!");
      "User Profile Updated", result;
    } catch (err) {
      "error", err;
    }
  };
  deleteUserFromCognitoGrp = () => {
    let { inspectorType } = this.state;
    let { iamInspector, iamMechanic } = this.state;

    const { user } = this.props;
    Auth.currentCredentials()
      .then(credentials =>
        Promise.resolve(
          new CognitoIdentityServiceProvider({
            apiVersion: "2016-04-18",
            credentials: Auth.essentialCredentials(credentials),
            region: "us-east-2"
          })
        )
      )
      .then(client => {
        //handle group addition
        if (iamMechanic) {
          if (!inspectorType.includes("MECHANIC")) {
            client
              .adminAddUserToGroup({
                GroupName: "Mechanics",
                UserPoolId: user.pool.userPoolId,
                Username: user.username
              })
              .promise();
          }
        } else {
          if (inspectorType.includes("MECHANIC")) {
            client
              .adminRemoveUserFromGroup({
                GroupName: "Mechanics",
                UserPoolId: user.pool.userPoolId,
                Username: user.username
              })
              .promise();
          }
        }

        if (iamInspector) {
          if (!inspectorType.includes("INSPECTOR")) {
            client
              .adminAddUserToGroup({
                GroupName: "Inspectors",
                UserPoolId: user.pool.userPoolId,
                Username: user.username
              })
              .promise();
          }
        } else {
          if (inspectorType.includes("INSPECTOR")) {
            client
              .adminRemoveUserFromGroup({
                GroupName: "Inspectors",
                UserPoolId: user.pool.userPoolId,
                Username: user.username
              })
              .promise();
          }
        }
      });
    let newIType = [];
    if (this.state.iamInspector) newIType.push("INSPECTOR");
    if (this.state.iamMechanic) newIType.push("MECHANIC");
    this.setState({ inspectorType: newIType });
  };
  uploadImages = async () => {
    qualificationsArray = [];
    let { qualifications } = this.state;
    if (
      qualifications === undefined ||
      qualifications === null ||
      qualifications.length === 0
    ) {
      ("No Qualifications");
      return;
    }
    await Promise.all(
      qualifications.length !== 0 &&
        qualifications.map(async (obj, index) => {
          "[INDEX]", index, "qualificationsArray", qualificationsArray;

          if (obj["dateAchieved"] !== undefined) {
            let attachment = null;
            if (obj.attachment !== null) {
              attachment = {
                bucket: obj.attachment.bucket,
                region: obj.attachment.region,
                key: obj.attachment.key
              };
            }
            "[obj]1",
              {
                title: obj.title,
                dateAchieved: obj.dateAchieved,
                attachment
              };
            qualificationsArray.push({
              title: obj.title,
              dateAchieved: obj.dateAchieved,
              attachment
            });
            // ("[Date Achieved]:", index, qualificationsArray);
          } else {
            if (obj.file === null) {
              qualificationsArray.push({
                title: obj.title,
                dateAchieved: currentDate,
                attachment: null
              });

              "[obj] no file UPload",
                {
                  title: obj.title,
                  dateAchieved: currentDate,
                  attachment: null
                };
              // ("[file not attached]:", index, qualificationsArray);
            } else {
              try {
                let key = await Storage.put(
                  new Date().getTime() + obj.file.name,
                  obj.file
                );
                "uploaded",
                  {
                    title: obj.title,
                    dateAchieved: currentDate,
                    attachment: {
                      bucket: "calbitwebappuploadbucket1254-dev",
                      region: "us-east-2",
                      key: key.key
                    }
                  };
                qualificationsArray.push({
                  title: obj.title,
                  dateAchieved: currentDate,
                  attachment: {
                    bucket: "calbitwebappuploadbucket1254-dev",
                    region: "us-east-2",
                    key: key.key
                  }
                });
                // ("[file attached]:", index, qualificationsArray);
              } catch (err) {
                "Image Upload Error", err;
              }
            }
          }
          // })
        })
    );
  };

  uploadInspectorPic = async () => {
    let key = "";
    try {
      /*
      let { rawPicture } = this.state;
      if (rawPicture === undefined || rawPicture === null) {
        //("No Picture to Upload");
        return;
      }
*/
      key = await Storage.put(
        new Date().getTime() + this.state.rawPicture.name,
        this.state.rawPicture
      );
    } catch (err) {
      "Image Upload Error", err;
    }
    await this.setState({ uploadedPicKey: key.key });
  };
  _onFocus = e => {
    e.currentTarget.type = "date";
  };
  _onBlur = e => {
    e.currentTarget.type = "text";
  };
  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("../user");
  };
  onCancel = () => {
    this.setState({ open: false });
  };
  openEditModel = e => {
    e.preventDefault();
    this.setState({ open: true });
  };
  render() {
    let { classes } = this.props;
    let { open } = this.state;
    return (
      <div>
        <main ref="main" App>
          <EditConfirm
            onCancel={this.onCancel}
            onConfrim={this.handleSubmit}
            open={open}
          />
          <ToastContainer />
          <GridContainer>
            <GridItem xs={12} sm={12} md={8}>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card>
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>Update Profile</h4>
                      <p className={classes.cardCategoryWhite}>
                        Update Information Below
                      </p>
                    </CardHeader>
                    <CardBody>
                      <Form onSubmit={this.handleSubmit} role="form">
                        <div>
                          <Row form style={{ marginTop: "20px" }}>
                            <Col>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="fName"
                                    onChange={this.onInputChange}
                                    placeholder="Name"
                                    type="text"
                                    value={this.state.fName}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="email"
                                onChange={this.onInputChange}
                                placeholder="Email"
                                type="email"
                                value={this.state.email}
                              />
                            </InputGroup>
                          </FormGroup>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    value={this.state.password}
                                    id="password"
                                    onChange={this.onInputChange}
                                    placeholder="Password"
                                    type="password"
                                  />
                                </InputGroup>
                              </FormGroup>
                              {/*<div className="text-muted font-italic">
                                                      <small>
                                                       {` `} password strength:{" "}
                                                        <span className="text-success font-weight-700">
                                                          strong
                                                        </span>
                                                      </small>
                                                    </div> */}
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="cPassword"
                                    onChange={this.onInputChange}
                                    placeholder="Confirm Password"
                                    type="password"
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>

                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="address"
                                onChange={this.onInputChange}
                                placeholder="Address"
                                type="text"
                                value={this.state.address}
                              />
                            </InputGroup>
                          </FormGroup>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="city"
                                    onChange={this.onInputChange}
                                    placeholder="City"
                                    type="text"
                                    value={this.state.city}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="st"
                                    onChange={this.onInputChange}
                                    placeholder="State"
                                    type="text"
                                    value={this.state.st}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="phoneNum"
                                    onChange={this.onInputChange}
                                    placeholder=" Phone No"
                                    type="tel"
                                    value={this.state.phoneNum}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="date"
                                    placeholder="Inspecting Since"
                                    type="text"
                                    onFocus={e => this._onFocus(e)}
                                    onBlur={e => this._onBlur(e)}
                                    onChange={this.onInputChange}
                                    value={this.state.date}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <Cd style={{ marginTop: "20px" }}>
                          <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                            <div className="row">
                              <p className="col">
                                <h4>Employment History</h4>
                              </p>
                              <div className="col">
                                <Experiences
                                  addExperience={this.addExperience}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {this.state.experiences !== null &&
                              this.state.experiences.length !== 0 &&
                              this.state.experiences.map((item, key) => {
                                return (
                                  <div>
                                    <h5 style={{ color: "black" }}>
                                      {item.jobTitle}
                                    </h5>
                                    <div className="row">
                                      <div className="col-6">
                                        <p>Company:{" " + item.company}</p>
                                      </div>
                                      <div className="col-2">
                                        <input
                                          type="button"
                                          onClick={() =>
                                            this.deleteExperience(item.jobTitle)
                                          }
                                          value="X"
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Cd>
                        <Cd style={{ marginTop: "20px" }}>
                          <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                            <div className="row">
                              <p className="col">
                                <h4> Qualifications</h4>
                              </p>
                              <div className="col">
                                <Qualifications
                                  addQualification={this.addQualification}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {this.state.qualifications !== null &&
                              this.state.qualifications.length !== 0 &&
                              this.state.qualifications.map((item, key) => {
                                return (
                                  <div>
                                    <div className="row">
                                      <div className="col-4">
                                        <h5>{item.title}</h5>
                                      </div>
                                      <div className="col-6">
                                        <p>
                                          {item.file !== null &&
                                          item.attachment === undefined ? (
                                            "File Uploaded"
                                          ) : item.attachment !== undefined &&
                                            item.attachment !== null ? (
                                            <p>File Uploaded</p>
                                          ) : (
                                            <p>No File Uploaded</p>
                                          )}
                                        </p>
                                      </div>
                                      <div className="col-2">
                                        <input
                                          type="button"
                                          onClick={() =>
                                            this.deleteQualification(item.title)
                                          }
                                          value="X"
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Cd>
                        <Cd style={{ marginTop: "20px" }}>
                          <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                            <h4>Skills</h4>
                          </CardHeader>
                          <CardBody>
                            {this.state.skills !== null &&
                              this.state.skills.length !== 0 &&
                              this.state.skills.map((item, key) => {
                                return (
                                  <Chip
                                    key={key}
                                    style={{ margin: 5 }}
                                    label={item}
                                    onDelete={() => this.deleteSkill(item)}
                                  />
                                );
                              }, this)}
                            <div className="row" style={{ marginTop: 7 }}>
                              <div className="col" style={{ paddingRight: 0 }}>
                                <Input
                                  id="skill"
                                  placeholder="Skill Name"
                                  value={this.state.skill}
                                  onChange={this.onInputChange}
                                  inputProps={{
                                    "aria-label": "Description"
                                  }}
                                />
                              </div>
                              <div className="col" style={{ paddingLeft: 0 }}>
                                <Btn
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    this.addSkill(this.state.skill)
                                  }
                                >
                                  +
                                </Btn>
                              </div>
                            </div>
                          </CardBody>
                        </Cd>

                        <div>
                          <div className="text-center">
                            <Row lg="12" className="px-3 ">
                              <Col lg="2"></Col>
                              <Col>
                                <Btn
                                  className=" btn-lg btn-block mt-2"
                                  color="success"
                                  onClick={this.cancelForm}
                                >
                                  {"<< "}Back
                                </Btn>
                              </Col>
                              <Col>
                                <Btn
                                  className=" btn-lg btn-block mt-2"
                                  color="primary"
                                  type="button"
                                  onClick={this.openEditModel}
                                >
                                  Update Profile
                                </Btn>
                              </Col>
                              <Col lg="2"></Col>
                            </Row>
                          </div>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card profile>
                <div>
                  <CardAvatar profile style={{ width: 250, height: 250 }}>
                    <a
                      href="#pablo"
                      onClick={e => {
                        e.preventDefault();
                        document.getElementById("insp-pic").click();
                      }}
                    >
                      <img src={this.state.picture} alt="..." />

                      <Icon
                        style={{
                          position: "absolute",
                          left: "55%",
                          right: "45%",
                          top: 55,
                          color: "black"
                        }}
                      >
                        camera_alt
                      </Icon>
                    </a>
                  </CardAvatar>
                </div>
                <CardBody profile>
                  <input
                    id="insp-pic"
                    onChange={e => {
                      this.setState({
                        picture: URL.createObjectURL(e.target.files[0]),
                        rawPicture: e.target.files[0],
                        isPicChanged: true
                      });
                    }}
                    style={{ display: "none" }}
                    type="file"
                  />
                  <h6 className={classes.cardCategory}>
                    {this.state.company} Your Subscriptions
                  </h6>
                  <Cd style={{ marginTop: "10px", fontWeight: "bold" }}>
                    <CardBody>
                      <Row lg="12" style={{ paddingTop: 20 }} className="px-3 ">
                        <Col>
                          {this.state.iamInspector
                            ? "Inspector role selected"
                            : "Register me as Inspector"}
                          <span style={{ float: "right" }}>
                            <Switch
                              checked={this.state.iamInspector}
                              onChange={this.onInspMechStats}
                              value="iamInspector"
                              inputProps={{
                                "aria-label": "secondary checkbox"
                              }}
                            />
                          </span>
                        </Col>
                      </Row>
                      <Row lg="12" className="px-3">
                        <Col>
                          {this.state.iamMechanic
                            ? "Mechanic role selected"
                            : "Register me as Mechanic"}
                          <span style={{ float: "right" }}>
                            <Switch
                              checked={this.state.iamMechanic}
                              onChange={this.onInspMechStats}
                              value="iamMechanic"
                              inputProps={{
                                "aria-label": "secondary checkbox"
                              }}
                            />
                          </span>
                        </Col>
                      </Row>
                    </CardBody>
                  </Cd>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    data: state.vehicles.data,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    updateProfile: data => dispatch(actionTypes.updateProfile(data))
  };
};
export default UpdateInspector = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UpdateInspector));



// WEBPACK FOOTER //
// ./src/Inspector/UpdateInspector.js